<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title"> {{'user.migration' | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col"> #</th>
            <th scope="col"></th>
            <th scope="col">{{'user.role' | translate}}</th>
            <th scope="col">{{'event.target_group' | translate}}</th>
            <th scope="col">{{'user.gender' | translate}}</th>
            <th scope="col">{{'user.phone' | translate}}</th>
            <th scope="col">{{'user.address' | translate}}</th>
            <th scope="col">{{'event.credits' | translate}}</th>
            <th scope="col">{{'booked' | translate}}</th>
            <th>
              <mat-checkbox [(ngModel)]="all" (change)="selectAll()"></mat-checkbox>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of users; track item; let i = $index) {
            <tr>
              <th scope="row" (click)="openTgDialog(item, index)">
                {{i + 1}}.
              </th>
              <td (click)="openTgDialog(item, index)">
                @if (item.imported) {
                  <mat-icon style="color: green">check_circle_outline</mat-icon>
                }
                <ng-container>
                  <p class="one-line-text"><b>{{item.lastName}}</b></p>
                  <br>
                    <p class="one-line-text">{{item.firstName}}</p>
                  </ng-container>
                </td>
                <td (click)="openTgDialog(item, index)"> {{item.type}}</td>
                @if (item.tg) {
                  <td (click)="openTgDialog(item, index)">
                    {{item.tg.ageMask}}
                  </td>
                }
                @if (!item.tg) {
                  <td (click)="openTgDialog(item, index)">
                    -
                  </td>
                }
                <td (click)="openTgDialog(item, index)">
                  {{item.gender}}
                </td>
                <td (click)="openTgDialog(item, index)">
                  <ng-container>
                    @if (item.phone) {
                      <p class="one-line-text" style="display: flex;"><i class="material-icons">
                        phone
                      </i>{{item.phone}}</p>
                    }
                    @if (item.phone) {
                      <br>
                      }
                      @if (item.mobile) {
                        <p class="one-line-text"  style="display: flex;"><i class="material-icons">
                          phone_iphone
                        </i>{{item.mobile}}</p>
                      }
                      @if (item.mobile) {
                        <br >
                      }
                      @if (item.mail) {
                        <p  class="one-line-text"  style="display: flex;"><i class="material-icons">
                          mail
                        </i>{{item.mail}}</p>
                      }
                    </ng-container>
                  </td>
                  <td (click)="openTgDialog(item, index)">
                    <ng-container>
                      <p class="one-line-text">{{item.cityLocation + ', ' + item.postcode }}</p>
                      <br>
                        <p class="one-line-text">{{item.street + ' ' +  item.number}}</p>
                      </ng-container>
                    </td>
                    <td (click)="openTgDialog(item, index)">
                      {{item.sum}}
                    </td>
                    <td (click)="openTgDialog(item, index)">
                      @if (item.eventsBooked) {
                        <span>{{item.eventsBooked.length}}</span>
                      }
                      @if (!item.eventsBooked) {
                        <span></span>
                      }
                    </td>
                    <td>
                      @if (!item.imported) {
                        <mat-checkbox (change)="checkAll()" [(ngModel)]="item.selected"></mat-checkbox>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            @if (!msg) {
              <mat-spinner style="margin: auto;"></mat-spinner>
            }
            @if (msg !== 'done') {
              <h2 style="text-align: center;">{{msg | translate}}</h2>
            }
          </div>
        </div>
        <div mat-dialog-actions class="action-button-dialog" style="margin: 1px">
          <button mat-raised-button style="padding: 0px 10px;" class="save-button mat-accent" (click)="saveEvent()">CONFIRM</button>
        </div>
      </div>
